preventDataLoad